import { ExchangeError } from '../../../errors.js';
const SERVER = new URL('https://api.criptointercambio.com/v2');
const getCicOrder = async ({ message, headers, signature, }, fetchival) => {
    const response = await fetchival(SERVER, {
        headers: { ...headers, sign: signature },
    }).post(message);
    if (!response?.result) {
        throw new ExchangeError({ message: JSON.stringify(response) });
    }
    return response.result[0];
};
const getProviderOrder = async (providerOrder, fetchival) => {
    if (!providerOrder.options?.statusRequestParams?.v2) {
        throw new ExchangeError({ message: 'Missing v2 headers for CIC' });
    }
    const orderInfo = await getCicOrder(providerOrder.options.statusRequestParams.v2, fetchival);
    return {
        orderId: orderInfo.id,
        depositAddress: orderInfo.payinAddress,
        depositAmount: orderInfo.amountExpectedFrom,
        withdrawalAddress: orderInfo.payoutAddress,
    };
};
const cicConfig = {
    cic: getProviderOrder,
    cicus: getProviderOrder,
};
export default cicConfig;
